


























































import path from "path";
import { Route } from "vue-router";
import { isExternal } from "@/utils/validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import Item from "./Item.vue";
import AppLink from "./Link.vue";

@Component({
  // Set 'name' here to prevent uglifyjs from causing recursive component not work
  // See https://medium.com/haiiro-io/element-component-name-with-vue-class-component-f3b435656561 for detail
  name: "SidebarItem",
  components: {
    Item,
    AppLink
  }
})
export default class SidebarItem extends Vue {
  @Prop({ required: true }) private item!: Route;
  @Prop({ default: false }) private isNest!: boolean;
  @Prop({ default: "" }) private basePath!: string;
  @Prop({ default: { roles: [] } }) private account!: any;

  private onlyOneChild: Route | null = null;

  public getTitle(title: string) {
    return this.$t(`route["${title}"]`);
  }


  hasPermission(route) {
    if (route.meta && route.meta.roles) {
      return this.account.roles.some((role) => route.meta.roles.includes(role));
    } else {
      return true;
    }
  }

  private hasOneShowingChild(children: Route[]) {
    if (!children) {
      return false;
    }
    const showingChildren = children.filter((item: Route) => {
      if (item.meta && item.meta.hidden) {
        return false;
      } else {
        this.onlyOneChild = item; // This will only be used if hasOneShowingChild return true
        return true;
      }
    });
    return showingChildren.length === 1;
  }

  private resolvePath(routePath: string) {
    if (this.isExternalLink(routePath)) {
      return routePath;
    }
    return path.resolve(this.basePath, routePath);
  }

  private isExternalLink(routePath: string) {
    return isExternal(routePath);
  }

  private childrenFilter(children: Route[]) {
    return children.filter(child => !child.meta || !child.meta.hidden);
  }
}
